const config = {
  BACKEND_CORE_URL: process.env.REACT_APP_BACKEND_URL,
  BACKEND_CORE_V2_URL: process.env.REACT_APP_BACKEND_V2_URL,
  PATIENT_INFO_ENDPOINT: process.env.REACT_APP_BACKEND_PATIENT_BASE_URL,
  SEARCH_PATIENT_PATH: process.env.REACT_APP_BACKEND_SEARCH_PATIENT_BASE_URL,
  WEB_SOCKET_ENDPOINT: process.env.REACT_APP_WEBSOCKET_URL,
};
export default config;
